const { io } = require('socket.io-client');
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const socket = io(API_BASE_URL, {
  transports: ['websocket']
});

socket.on('connect_error', () => {
  socket.io.opts.transports = ['polling', 'websocket'];
});

export default socket;
